import React from "react";
import { Link } from "react-router-dom";

// Understated outlined button/link. Transparent fill, thin outline, small-caps.
// variant: "ink" (default) or "oxblood". reversed for dark sections.
export const OutlineLink = ({
  to,
  children,
  variant = "ink",
  reversed = false,
  onClick,
  type,
  as = "link",
  testid,
  className = "",
  target,
  rel,
}) => {
  const base =
    "inline-flex items-center justify-center bg-transparent px-8 py-4 text-[11px] uppercase tracking-[0.28em] transition-colors duration-500 cursor-pointer border";

  let styleClasses;
  if (reversed) {
    styleClasses =
      "border-[#F4F1EA] text-[#F4F1EA] hover:bg-[#F4F1EA] hover:text-[#1C1A17]";
  } else if (variant === "oxblood") {
    styleClasses =
      "border-[#7A2E2E] text-[#7A2E2E] hover:bg-[#7A2E2E] hover:text-[#F4F1EA]";
  } else {
    styleClasses =
      "border-[#1C1A17] text-[#1C1A17] hover:bg-[#1C1A17] hover:text-[#F4F1EA]";
  }

  const classes = `${base} ${styleClasses} ${className}`;

  if (as === "button") {
    return (
      <button type={type || "button"} onClick={onClick} className={classes} data-testid={testid}>
        {children}
      </button>
    );
  }

  if (as === "anchor") {
    return (
      <a href={to} onClick={onClick} className={classes} data-testid={testid} target={target} rel={rel}>
        {children}
      </a>
    );
  }

  return (
    <Link to={to} onClick={onClick} className={classes} data-testid={testid}>
      {children}
    </Link>
  );
};
